import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { resetPassword } from "../../services/Api";
import { useToast } from '../../services/ToastContext';

const ResetPasswordPage = () => {
  const { token } = useParams(); // This will get the token from the URL
  const { showToast } = useToast();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      await resetPassword(token, password);
      setSuccess(true);
      showToast("Password Successfully Reset")
    } catch (error) {
      // setError(error.message || "Failed to reset password");
      showToast("Failed to reset password. Reset email may be expired.", "error")
    }
  };

  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-12 col-md-9">
            <div className="card o-hidden border-0 shadow-lg my-5">
              <div className="card-body p-0">
                <div className="row">
                  <div className="col-lg-2 d-none d-lg-block bg-password-image" />
                  <div className="col-lg-8">
                    <div className="p-5">
                      <div className="text-center">
                        <h1 className="h4 text-gray-900 mb-2">
                          Reset Your Password
                        </h1>
                        <p className="mb-4">
                          What would you like your new password to be?
                        </p>
                      </div>
                      
                      {success ? (
                        <div className="text-center">
                          <Link to="/login" className="btn btn-primary">
                            Return to Login
                          </Link>
                        </div>
                      ) : (
                        <form className="user" onSubmit={handleSubmit}>
                          <div className="form-group">
                            <input
                              type="password"
                              className="form-control form-control-user"
                              placeholder="New Password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              required
                            />
                          </div>
                          <div className="form-group">
                            <input
                              type="password"
                              className="form-control form-control-user"
                              placeholder="Confirm New Password"
                              value={confirmPassword}
                              onChange={(e) => setConfirmPassword(e.target.value)}
                              required
                            />
                          </div>
                          {error && (
                            <div className="alert alert-danger" role="alert">
                              {error}
                            </div>
                          )}
                          <button
                            type="submit"
                            className="btn btn-primary btn-user btn-block"
                          >
                            Reset Password
                          </button>
                        </form>
                      )}
                      <hr />
                      <div className="text-center">
                        <Link to="/login" className="small">
                          Return to Login
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPasswordPage;